import { FC } from 'react';

import { LoginLayoutHeader } from '@gem/components';

import { StatusIllustration } from '../StatusIllustration/StatusIllustration';
import styles from './StatusHeader.styles.m.css';

interface IStatusHeaderProps {
  title?: string;
  status: 'error' | 'success';
}

export const StatusHeader: FC<IStatusHeaderProps> = (props) => {
  const { title, status } = props;
  return (
    <div className={styles.container}>
      <StatusIllustration status={status} />
      <LoginLayoutHeader className={styles.title}>{title}</LoginLayoutHeader>
    </div>
  );
};
